import { AdminApiService } from '../services';

export const getLlmDefaultModel = () => {
  return AdminApiService.getLlmDefaultModelApiAdminLlmDefaultModelGet();
};

export const testLlmModel = (model: string) => {
  return AdminApiService.testLlmModelApiAdminLlmTestModelPost({ model });
};
